<!--高级模板-设置变量-->
<template>
  <!--创建合同-->
  <el-container class="to-create">
    <!--左侧-->
    <el-aside width="2.80rem" class="aside-left" :style="{ height: boxHeight }">
      <p class="page-total">
        共{{ contractInfo.items }}页
        <a
          href="javascript: void(0)"
          @click="
            apiMethods.FileOperController.download_down({
              targetId: contractInfo.contractId,
              fileType: fileType,
              sign: contractInfo.sign,
              ts: contractInfo.ts,
              fix: '.pdf',
            })
          "
          class="fr color-success cred"
          >下载</a
        >
      </p>
      <div class="page-con">
        <template v-for="(i,index) in contractInfo.items">
          <div
            @click="getContractDetailByNum(i)"
            :key="index"
            :class="currentInfo.page === i ? 'active' : ''"
            class="list"
          >
            <img v-if="contractList[i]" :src="contractList[i].url" />
            <img v-else src="/images/contr_default.jpg" alt="" />
            <span>{{ i }}</span>
          </div>
        </template>
      </div>
      <div class="go-Page">
        <div>
          <div>
            <div class="bd">
              <el-input
                v-model="goPageNum"
                placeholder="输入页码"
                type="number"
                @keyup.enter.native="handleContractPageClick"
              />
              /{{ contractInfo.items }}
            </div>
            <a @click="handleContractPageClick">GO</a>
          </div>
        </div>
      </div>
    </el-aside>
    <!--合同显示详情-->
    <el-main class="main-content" :style="{ height: boxHeight }">
      <contract-view
        ref="contractView"
        :contract-info.sync="currentInfo"
        :page="currentInfo.page"
        :items="contractInfo.items"
        :scaleValue.sync="scaleValue"
        :chapter-list.sync="chapteList"
        @pre-page="getContractDetailByNum($event)"
        @next-page="getContractDetailByNum($event)"
        @toCurrentPage="toCurrentPage"
      />
      <!--添加附件-->
      <div ref="accessory" class="text-center accessory-box">
        <!-- 去顶部去底部按钮-->
        <template
          v-if="contractInfo && contractInfo.items && contractInfo.items > 1"
        >
          <span class="jumpFirst" @click="goPageAndFixed(1)"
            ><img src="../../../assets/images/btn-down.png"
          /></span>
          <span class="jumpLast" @click="goPageAndFixed(contractInfo.items)"
            ><img src="../../../assets/images/btn-down.png"
          /></span>
        </template>
      </div>
    </el-main>
    <!--右侧-->
  </el-container>
</template>

<script>
import ContractView from "../../../components/advancedVersion/contractView";
import {
  convertDetailToShow,
  postFileTempUpload2,
  tempConvertToContract,
  ApiMethods,
} from "@/assets/js/http-serve/http-methods";
import { isMobileDevice } from "@/assets/js/utils/others";
export default {
  components: { ContractView },
  data () {
    return {
      apiMethods: ApiMethods,
      boxHeight: "1170px",
      goPageNum: null, // 前往多少页
      // .............合同相关.............
      // 合同信息查看相关变量
      contractInfo: {
        items: 0,
        ts: null,
        sign: null,
        docHash: null,
        contractId: null,
        contractName: ""
      },
      // 合同列表
      contractList: [],
      // 合同的签章列表 {offsetX: '0.5', offsetY: '0.5', cindex: 0章顺序不分甲乙方和页数, signOwner: 甲乙方, url: 章地址， page: 0合同页数}
      chapteList: [],
      // 当前页信息
      currentInfo: { page: 1, url: "" },
      // 合同缩放比例
      scaleValue: 100,
    };
  },

  mounted () {
    const isMobile = isMobileDevice();
    const {targetId,fileType,sign,ts}=this.$route.query;
    if(isMobile) {
      window.location.href=`${this.globalConfig.domain.junziqianH5Op}/advancedVersion/APICust/resPreview?targetId=${targetId}&fileType=${fileType}&sign=${sign}&ts=${ts}`
    }
    this.boxHeight = document.body.clientHeight - 60 + "px";
    this.convertContractToInfo({
      targetId,
      fileType,
      sign,
      ts,
    });
  },
  beforeDestroy (next) {},
  watch: {},
  computed: {},
  methods: {
    loadingStart (info = null) {
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    //设置状态
    loadingClose () {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
    // 查询合同页数等信息
    convertContractToInfo (param) {
      this.loadingStart("正在加载合同信息");

      tempConvertToContract(param)
        .then(({ data }) => {
          this.loadingClose();

          let tempFile = data.tempFile || {
            ts: param.ts,
            sign: param.sign,
            targetId: param.targetId,
            fileType: param.fileType
          };
          this.contractInfo.docHash = data.docHash;
          this.contractInfo.ts = tempFile.ts;
          this.contractInfo.sign = tempFile.sign;
          this.contractInfo.items = parseInt(data.items);
          this.contractInfo.contractId = tempFile.targetId;
          this.contractInfo.contractName = param.contractName;
          this.currentInfo = { page: 1, url: "" };
          this.fileType = tempFile.fileType || 1;

          this.getContractDetailByNum(1);
        })
        .catch(err => {
          this.loadingClose();
          console.error("合同文件转换 " + JSON.stringify(err));
        });
    },

    // 输入input合同跳页
    handleContractPageClick () {
      let page = this.goPageNum;
      page = parseFloat(page);
      if (!page) return this.$message.warning("请输入正确的页数");
      if (page < 1 || page > this.contractInfo.items)
        return this.$message.warning("请输入正确的页数");
      this.goPageAndFixed(page);
    },
    //  按页数获取合同，在左侧目录定位当前页，中间合同滚动到顶部从头展示
    goPageAndFixed (page) {
      this.getContractDetailByNum(page);
      this.toCurrentPage(page);
      document.querySelectorAll(".contract-view")[0].scrollTop = 0;
    },
    // 页数跳转，定位到当前展示页,定位左侧图片
    toCurrentPage (val) {
      let dom = document.querySelectorAll(".page-con .list")[val - 1];
      if (dom) {
        document.querySelectorAll(".page-con")[0].scrollTop = dom.offsetTop;
      }
    },
    // 按页数获取合同
    getContractDetailByNum (num) {
      if (this.contractList[num]) {
        return (this.currentInfo = this.contractList[num]);
      }

      this.currentInfo = {
        page: num,
        url: convertDetailToShow({
          sign: this.contractInfo.sign,
          ts: this.contractInfo.ts,
          fileType: this.fileType,
          fix: "png",
          targetId: this.contractInfo.contractId,
          num: num - 1,
          docHash: this.contractInfo.docHash
        })
      };

      if (!this.contractList[num]) {
        this.contractList[num] = this.currentInfo;
      }
    },
    //。。。。。。。。。。。。。。。右侧相关 end。。。。。。。。。。。。。
  },
  layout: "fullpage",
  head: { title: "模板设置" },
  name: "setVariable"
};
</script>

<style lang="less" scoped>
@import (less) "../../../assets/style/icon.css";

.font-elips() {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.to-create {
  margin: -20px;
}

@mg: 0.2rem; // 左右side给中间合同流的间距

.aside-left {
  /*padding-top: .20rem;*/
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #ffffff;
  box-shadow: 0.02rem 0.03rem 0.16rem rgba(0, 0, 0, 0.12);
  position: relative;
  z-index: 3;
  margin-right: @mg;

  .cred {
    color: #ec1c1c;
  }

  .list.active img {
    border-color: #ec1c1c;
  }

  .list.active span {
    background-color: #ec1c1c;
  }

  .list {
    position: relative;
    margin: 0 0.3rem 0.2rem 0.3rem;
    cursor: pointer;

    span {
      position: absolute;
      bottom: 2px;
      right: 0;
      display: block;
      /*width: 20px;*/
      /*height: 20px;*/
      width: 0.4rem;
      height: 0.3rem;
      line-height: 0.3rem;
      border-radius: 0.06rem 0px 0px 0px;
      color: #fff;
      background-color: #e3e3e3;
      text-align: center;
    }

    img {
      display: block;
      width: 100%;
      /*max-height: 230px !important;*/
      max-height: 3rem !important;
      box-sizing: border-box;
      margin-bottom: 0.1rem;
      border: 2px solid #e3e3e3;
    }
  }

  .page-total {
    color: #646464;
    font-size: 85%;
    padding: 0 0.3rem 0 0.3rem;
    height: 60px;
    line-height: 60px;
  }

  .page-con {
    overflow-y: auto;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0.9rem;
    top: 60px;
    box-sizing: border-box;
    padding-top: 0.2rem;
    border-top: 1px solid #f2f2f2;
  }

  // 跳转页面
  .go-Page {
    // height:60px;
    // line-height:60px;
    padding: 0.3rem 0;
    width: 100%;
    text-align: center;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 5;
    background-color: #ffffff;

    > div {
      display: inline-block;

      > div {
        display: flex;
        text-align: center;
        justify-content: space-between;
        align-items: center;
        height: 32px;
        line-height: 28px;
      }
    }

    .bd {
      height: 100%;
      box-sizing: border-box;
      border: 1px solid rgba(183, 183, 183, 1);
      border-style: solid none solid solid;
      display: flex;
      text-align: center;
      justify-content: space-between;
      align-items: center;
      padding-right: 0.05rem;
      border-radius: 0.04rem 0 0 0.04rem;
    }

    a {
      text-decoration: none;
      cursor: pointer;
      box-sizing: border-box;
      width: 0.6rem;
      border-radius: 0px 0.04rem 0.04rem 0.04rem;
      display: block;
      background: #999999;
      border: 1px solid #999999;
      color: rgba(255, 255, 255, 1);
      font-family: PingFang SC;
    }

    /deep/ .el-input {
      /*width: 75px;*/
      width: 1.2rem;
      height: 100%;
    }

    /deep/ .el-input__inner {
      font-size: 0.14rem;
      border: none;
      padding: 0 0 0 0.05rem;
      height: 100%;
      line-height: inherit;
    }
  }
}

.main-content {
  flex: 1;
  position: relative;
  /*display: table-cell;*/
  box-sizing: border-box;
  vertical-align: top;
  padding: 0;
  /*background: #ffffff;*/
  overflow: hidden;
  z-index: 2;

  .accessory-box {
    position: absolute;
    bottom: -106px;
    width: 100%;
    pointer-events: none;
    z-index: 8;

    .accessory-list {
      pointer-events: initial;
      position: relative;
      width: 100%;
      /*display: flex;*/
      /*justify-content: flex-start;*/
      /*flex-wrap: wrap;*/
      /*align-items: center;*/
      box-sizing: border-box;
      // border-top: 1px solid rgba(0,0,0,0.16);
      padding: 56px 15px 20px 15px;
      background: #ffffff;
      box-shadow: 0px -2px 12px rgba(0, 0, 0, 0.16);

      li {
        /*flex: none;*/
        /*display: table-cell;*/
        /*width: 100%;*/
      }

      .accessory-group {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: center;

        p.list-item {
          display: inline-block;
          position: relative;
          margin: 4px 25px 4px 0;
          padding: 6px 19px 6px 5px;
          // border: 4px;
          font-size: 12px;
          color: #000000;
          background: rgba(248, 248, 248, 1);

          > span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            max-width: 200px;
          }
        }

        i.del {
          color: #a1a1a1;
          position: absolute;
          right: -6px;
          top: -6px;
          font-size: 16px;
          cursor: pointer;
        }
      }

      .upload-accessory {
        /*width: 75px;*/
        overflow: hidden;
        position: relative;
        cursor: pointer;
        display: inline-block;

        &:hover {
          opacity: 0.5;
        }

        a {
          // font-size:16px;
          display: inline-block;
          width: 120px;
          line-height: 35px;
          color: #ec1c1c;
          font-weight: bold;
        }

        &:hover a {
          font-weight: 800;
        }

        /*input {*/
        /*  position: absolute;*/
        /*  width: 300px;*/
        /*  height: 300px;*/
        /*  top: -18px;*/
        /*  left: -73px;*/
        /*  cursor: pointer;*/
        /*  opacity: 0;*/
        /*}*/

        .up-icon {
          width: 16px;
          height: 16px;
          vertical-align: middle;
          margin-right: 5px;
        }

        .div-upload {
          /*cursor: pointer;*/
          border: 1px dashed #ec1c1c;
          width: 80px;
          height: 30px;
          line-height: 30px;
          display: inline-block;
          text-align: center;
          color: #ec1c1c;
          font-size: 18px;
          font-weight: normal;
          position: relative;
          z-index: 2;
        }

        .input-upload {
          cursor: pointer;
          position: absolute;
          z-index: 3;
          left: 0;
          top: 0;
          bottom: 0;
          right: 0;
          opacity: 0;
        }
      }
    }

    div.btn {
      pointer-events: initial;
      display: inline-block;
      // width: 120px;
      // height: 35px;
      // line-height: 35px;
      padding: 0 10px;
      font-size: 14px;
      // color: #ffffff;
      // background: #a2a5ac;
      // border-radius: 3px 3px 0 0;
      cursor: pointer;
      width: 150px;
      height: 45px;
      line-height: 45px;
      background: rgba(255, 255, 255, 0.65);
      box-shadow: 0px -2px 12px rgba(0, 0, 0, 0.16);
      border-radius: 6px 6px 0px 0px;
      color: #ec1c1c;
      font-size: 15px;
      font-weight: bold;

      .arrow {
        margin-left: 15px;
        font-size: 12px;
        font-weight: bold;
        vertical-align: middle;
        display: inline-block;
        margin-top: -2px;
      }
    }
  }
}

.aside-right {
  color: #290202;
  box-sizing: border-box;
  // padding: 20px 20px 0 20px;
  background-color: #ffffff;
  overflow: hidden;
  position: relative;
  box-shadow: -0.02rem 0px 0.16rem rgba(0, 0, 0, 0.12);
  z-index: 3;
  margin-left: @mg;
  padding-bottom: 1.7rem;

  .t2 {
    /*color: #000000;*/
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
  }

  .t3 {
    color: rgba(0, 0, 0, 0.85);
    font-weight: normal;
    padding-left: 0.3rem;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 0.17rem;
    font-size: 12px;
  }
  .text-tip {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    > i {
      margin: 0 10px;
    }
    .text {
      padding: 0 5px;
      border: 1px solid #ec1c1c;
      background-color: #fef3f3;
      color: #7f7f7f;
    }
  }
  .m-title {
    .t2();
    position: relative;
    margin-bottom: 0.15rem;
    padding-left: 0.32rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: start;

    .el-icon-question {
      margin-top: 0.02rem;
    }
  }

  .spec {
    line-height: 0.35rem;
    .t-span {
      top: 0.06rem;
    }
    .el-icon-question {
      margin-top: 0.08rem;
    }
  }

  .st1 {
    width: 100%;
    cursor: pointer;
  }
  .choose {
    background-color: rgba(236, 28, 28, 0.05);
    color: #ec1c1c;
  }

  .t-span {
    position: absolute;
    left: 0;
    top: 0;
    vertical-align: middle;
    display: inline-block;
    text-align: center;
    width: 0.22rem;
    height: 0.22rem;
    line-height: 0.22rem;
    background: rgba(236, 28, 28, 1);
    border-radius: 50%;
    font-size: 0.16rem;
    color: #ffffff;
    font-weight: normal;
    /*background: url(../../assets/images/icon-n1.png) no-repeat center center;*/
    /*background-size: 100% 100%;*/
  }

  .tp-box {
    width: 100%;
    min-height: 3.1rem;
    background: #ffffff;
    box-shadow: 0px 0.03rem 0.12rem rgba(0, 0, 0, 0.06);
    padding: 0.3rem 0.2rem 0.25rem 0.2rem;
    box-sizing: border-box;

    /deep/ .el-radio-group {
      width: 100%;
    }

    /deep/ .el-radio {
      color: #290202;
      width: 100%;
      height: 0.35rem;
      line-height: 0.35rem;
      border-radius: 0.02rem;
      padding: 0 0.1rem;
      box-sizing: border-box;
      margin-bottom: 0.05rem;

      &.is-checked {
        background-color: rgba(236, 28, 28, 0.05);
      }
    }

    /deep/ .el-radio__label {
      .font-elips();
      max-width: 90%;
      display: inline-block;
      vertical-align: top;

      span {
        display: inline-block;
        margin-right: 0.05rem;
        font-size: 0.12rem;
        color: #ec1c1c;
        padding: 1px 0.02rem;
        background: rgba(236, 28, 28, 0.1);
        line-height: initial;
        border-radius: 0.02rem;
      }
    }
  }

  .bc-box {
    color: rgba(41, 2, 2, 0.85);
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
    box-sizing: border-box;

    .flex-box {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      // display: inline-block;
    }

    .drop-one {
      cursor: move;
      font-size: 0.12rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(41, 2, 2, 0.85);
      /*margin: 0 .12rem .15rem .12rem;*/
      width: 24%;
      text-align: center;
      // float: right;
      margin-bottom: 0.17rem;

      span {
        display: block;
        width: 0.45rem;
        height: 0.45rem;
        margin: 0 auto 0.05rem auto;
      }
      // p{
      //   width: 0.45rem;
      // }

      &:hover {
        p {
          color: #ec1c1c;
        }

        .icon-txt1 {
          .icon-txt1-on();
        }

        .icon-txt2 {
          .icon-txt2-on();
        }

        .icon-number {
          .icon-number-on();
        }

        .icon-date {
          .icon-date-on();
        }

        .icon-phone {
          .icon-phone-on();
        }

        .icon-idcard {
          .icon-idcard-on();
        }

        .icon-yy {
          .icon-yy-on();
        }

        .icon-ss {
          .icon-ss-on();
        }

        .icon-email {
          .icon-email-on();
        }

        .icon-gz {
          .icon-gz-on();
        }

        .icon-qz {
          .icon-qz-on();
        }

        .icon-qzgz {
          .icon-qzgz-on();
        }
      }
    }
  }

  .bb-box {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    height: 149px;
    background: #ffffff;
    box-shadow: 0rem -0.03rem 0.12rem rgba(0, 0, 0, 0.06);
    opacity: 1;
    padding: 0.32rem 0.28rem;
    box-sizing: border-box;
    width: 100%;
  }
}

.jumpFirst {
  top: -80px;
  bottom: initial;
  pointer-events: initial;
}

.jumpLast {
  top: -25px;
  bottom: initial;
  pointer-events: initial;
}

.danger-btn {
  height: 35px;
  line-height: 35px;
  padding-top: 0;
  padding-bottom: 0;
  width: 100%;
  background-color: #ff0000;
  font-size: 14px;
}

.default-btn {
  flex: auto;
  height: 35px;
  line-height: 35px;
  padding: 0;
  margin: 0;
  color: rgba(41, 2, 2, 0.45);
  border: 1px solid rgba(220, 220, 220, 0.69);
  font-size: 14px;
  margin-left: 0.18rem;
  width: 1.28rem;

  &:first-child {
    margin-left: 0;
  }
}

.com-myDialog {
}
</style>



// WEBPACK FOOTER //
// pages/advancedVersion/APICust/resPreview.vue